import {ButtonColorTheme, PopupSize, PopupTemplate} from '..'
import {TempTaskSchedule} from '../../model/schedule'

export interface TaskScheduleDeletePopProps {
  schedule: TempTaskSchedule
  onClickConfirm: (schedule: TempTaskSchedule) => void
  onClickCancel: () => void
}

export const TaskScheduleDeletePop = (props: TaskScheduleDeletePopProps) => {
  const {schedule, onClickConfirm, onClickCancel} = props
  return (
    <PopupTemplate
      {...{
        title: 'Delete Schedule',
        description: 'Are you sure you want to delete this schedule?',
        background: true,
        popupSize: PopupSize.Small,
        handleClosePopup: onClickCancel,
        mainFunction: () => onClickConfirm(schedule),
        buttonContent: 'Delete',
        buttonColorTheme: ButtonColorTheme.Warning,
      }}
    />
  )
}
